var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Venezuela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.906,20.873l-0.125-0.898l-0.426,0.801l-0.895-0.156l0.629,0.652l-0.426,0.801l0.816-0.398 l0.629,0.656l-0.125-0.902l0.816-0.395L25.906,20.873z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.82,22.631l0.902-0.098l-0.785-0.453l0.188-0.891l-0.676,0.609l-0.785-0.453l0.367,0.828 l-0.672,0.609l0.902-0.098l0.371,0.832L28.82,22.631z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.074,24.725l0.879,0.223l-0.582-0.695l0.48-0.773l-0.84,0.344l-0.586-0.699l0.063,0.906 l-0.84,0.34l0.879,0.223l0.066,0.906L31.074,24.725z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.914,27.123l0.719-0.563l-0.91,0.035l-0.309-0.855l-0.25,0.875l-0.906,0.031l0.75,0.508 l-0.25,0.871l0.715-0.559l0.754,0.508L32.914,27.123z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.094,20.873l0.125-0.898l0.426,0.801l0.895-0.156l-0.629,0.652l0.426,0.801l-0.816-0.398 l-0.629,0.656l0.125-0.902l-0.816-0.395L22.094,20.873z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.18,22.631l-0.902-0.098l0.785-0.453l-0.188-0.891l0.676,0.609l0.785-0.453l-0.367,0.828 l0.672,0.609l-0.902-0.098l-0.371,0.832L19.18,22.631z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.926,24.725l-0.879,0.223l0.582-0.695l-0.48-0.773l0.84,0.344l0.586-0.699l-0.063,0.906 l0.84,0.34l-0.879,0.223l-0.066,0.906L16.926,24.725z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.086,27.123l-0.719-0.563l0.91,0.035l0.309-0.855l0.25,0.875l0.906,0.031l-0.75,0.508l0.25,0.871 l-0.715-0.559l-0.754,0.508L15.086,27.123z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Venezuela);
export default __webpack_public_path__ + "static/media/icons8-venezuela.1f94fd4c5ca71898bacad0a201a59eed.svg";
export { ForwardRef as ReactComponent };